<template>
  <div class="content1">
    <div class="nav_menu">
      <Menu :menu="menu"></Menu>
    </div>
    <div class="table">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import storage from 'store'
export default {
  components: {
    Menu
  },
  data () {
    let tab = this.$route.params.tab;
    let id = this.$route.params.id;
    let role = storage.get('role');
    let m=role[`${tab}m`]
    return {
      menu: [
        {
          text: '会议通知',
          to: `/files/hytz/${id}/${tab}`,
          show: m.includes('hytz'),
        },
        {
          text: '会议日程',
          to: `/files/hyrc/${id}/${tab}`,
          show: m.includes('hyrc')
        },
        {
          text: '会议文件',
          to: `/files/hywj/${id}/${tab}`,
          show: m.includes('hywj')
        },
        {
          text: '审议意见卡',
          to: `/files/syyjm/${id}/${tab}`,
          show: m.includes('syyjm')
        },
        {
          text: '餐宿安排',
          to: `/files/csap/${id}/${tab}`,
          show: m.includes('csap')
        },
        {
          text: '公报',
          to: `/files/gb/${id}/${tab}`,
          show: m.includes('gb')
        },
        // {
        //   text: '座次安排',
        //   to: `/files/zcap/${id}/${tab}`,
        //   show: m.includes('zcap']
        // }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.content1 {
  display: flex;
  height: 100%;
  .nav_menu {
    width: 200px;
    margin-right: 30px;
  }
  .table {
    flex-grow: 1;
    flex-shrink: 0;
    width: 0;
  }
}
</style>